import updateSms from './sms'
import updateLoan from "./loan";
import updatePayment from "./payment";
import updateApp from "./app";

const reducer = (state,action) => {
    return {
        app: updateApp(state,action),
        sms: updateSms(state,action),
        loan: updateLoan(state,action),
        payment: updatePayment(state,action)
    }
}
export default reducer;